/*
 *
 * CallUsModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 09-Jan-2025
*/

import CallUsModal from './CallUsModalContainer'

export default CallUsModal
